export const PAGE_TITLE_KEYS: Record<string, string> = {
  gallery: "gallery.title",
  cameras: "cameras.title",
  news: "menuOverlay.news",
  tickets: "tickets.title",
  profile: "profile.profile",
  "manage-users": "manageUsers.title",
  regions: "pageTitles.regions",
  "region-v2": "pageTitles.regions",
  "live-stream": "menuOverlay.liveStream",
  intro: "pageTitles.intro",
};
